module.exports = __webpack_public_path__ + "static/media/Illus-SummerEarly@2x.ab29892f.png";